import { useEffect, useState } from 'react';

// TODO: Investigar como testear el comportamiento
export default function useDesktop() {
  const [desktop, setDesktop] = useState(window.innerWidth > 768);

  const isDesktop = () => {
    const breakpoint = window.innerWidth > 768;

    setDesktop(breakpoint);
  };

  useEffect(() => {
    isDesktop();

    window.addEventListener('resize', isDesktop);

    return () => window.removeEventListener('resize', isDesktop);
  }, []);

  return desktop;
}
